import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import classnames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { weekDaysMon, weekDaysSun } from './constants';
import {
  splitArrayToArraysOfRow,
  getCurrentMonthDates,
  changeDateFormatFromTo,
} from 'helpers/_helpers';
import DayCell from './DayCell/DayCell';
import { adaptedDataHelper, getMonthSheets } from 'store/schedule/schedulePageOperation';
import schedulePageActions from 'store/schedule/schedulePageActions';
import { useDateSettingsFormat } from 'common/useDateSettingsFormat';
import { globalBEDateFormat } from 'common/dateFormatConfig';
import useV6MonthEvents from '../hooks/useV6MonthEvents';


const MonthViewCalendar = ({
  classes,
}) => {
  const dispatch = useDispatch();
  const { dateFormat } = useDateSettingsFormat();
  const weekStart = useSelector((state) => state.personalProfile.organization.settings.weekStart);
  const renderDays = weekStart === 'Sun' ? weekDaysSun : weekDaysMon;

  const selectedDate = useSelector((state) => state.schedule.selectedDate);
  const filters = useSelector((state) => state.schedule.filters);
  const showAllLocations = useSelector((state) => state.schedule.showAllLocations);
  const locations = useSelector((state) => state.personalProfile.activeLocations);
  const { events } = useV6MonthEvents();

  const [monthEvents, setMonthEvents] = useState([]);

  const fetchSheets = React.useCallback(
    (requestFilters) => {
      dispatch(
        getMonthSheets({
          filters: requestFilters,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    fetchSheets({ ...filters, allLocations: showAllLocations });
  }, [selectedDate, filters, showAllLocations, fetchSheets]);


  const handleSelectDay = (dayDate) => {;
    setDaySheetsBySelectDay(dayDate);
  };

  const setDaySheetsBySelectDay = (clickedDay) => {
    const formattedDay = changeDateFormatFromTo(dateFormat, globalBEDateFormat, clickedDay);
    const thisDaySheets = events?.[formattedDay] || [];
    dispatch(schedulePageActions.setSheets(adaptedDataHelper(thisDaySheets)));
  };

  useEffect(() => {
    const mappedEvents = getCurrentMonthDates(selectedDate, weekStart, dateFormat); // make empty cells
    const res = mappedEvents.map((dateObj, i) => {
      const formattedToStoreFormatDay = changeDateFormatFromTo(
        dateFormat,
        globalBEDateFormat,
        mappedEvents[i].dayNumber
      );

      // eslint-disable-next-line no-param-reassign
      dateObj.events = events?.[formattedToStoreFormatDay]?.map(({ sheet }) => sheet) || [];
      return dateObj;
    });
    setMonthEvents(splitArrayToArraysOfRow(res));
  }, [events, selectedDate, weekStart, dateFormat]);

  return (
    <div className={classnames(classes.monthCalendarWrapper)}>
      <div className={classnames(classes.calHeader)}>
        {renderDays.map((el, i) => (
          <div className={classnames(classes.headerCell)} key={i}>
            <div className={classes.calHeaderText}>{el}</div>
          </div>
        ))}
      </div>

      <div className={classes.grid}>
        {monthEvents.map((row, rowI) => (
          <div key={rowI} className={classes.gridRow}>
            {row.map((day) => {
              return (
                <DayCell
                  data={day}
                  // key={day.key}
                  key={day.dayNumber + day.events.length}
                  clickedDay={selectedDate}
                  setClickedDay={handleSelectDay}
                  // sheetsWithoutForemanIds={sheetsWithoutForemanIds}
                  sheetsWithoutForemanIds={[]}
                  showAllLocations={showAllLocations}
                  locations={locations}
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(MonthViewCalendar);
